const aditl = {

	elem: {
		component: document.querySelectorAll('.aditl'),
		items: document.querySelectorAll('.aditl__block'),
		nav: document.querySelectorAll('.aditl__nav a')
	},
	
	mql: {
		large: window.matchMedia('(min-width: 1024px)')
	},

	aditlObserver: null,
	

	init() {		
		if(aditl.elem.component.length > 0) {
			if(aditl.mql.large.matches) {
				aditl.elem.component.forEach(function(element) {
					element.classList.add('aditl--active');
					element.querySelector('.aditl__main').addEventListener('scroll', aditl.scroll);
					aditl.aditlObserver = new IntersectionObserver(aditl.changeBackground, { root: element.querySelector('.aditl__main'), rootMargin: '0px 0px -60% 0px', threshold: 0 });
					aditl.elem.items.forEach(function(element) {
						aditl.aditlObserver.observe(element);
					});
					aditl.elem.nav.forEach(function(element) {
						element.addEventListener('click', aditl.click);
					});
				});
			}
		}
	},

	changeBackground(entries) {
		entries.forEach(entry => {
			if(entry.isIntersecting) {
				let background = entry.target.dataset.background;
				let parent = entry.target.closest('.aditl');
				let selectedAold = parent.querySelector('.aditl__nav a.selected');
				let selectedAnew = parent.querySelector('.aditl__nav a[href="#' + background + '"]');
				let selectedImg = parent.querySelector('.aditl__bg-image--selected');
				if (selectedAold !== null) {
					selectedAold.classList.remove('selected');
				}
				if(selectedAnew !== null) {
					let height = selectedAnew.parentNode.offsetTop + selectedAnew.parentNode.offsetHeight;
					parent.style.setProperty('--progress-height', height + 'px');
				} else {
					let height = 0;
					parent.style.setProperty('--progress-height', height + 'px');					
				}
				if (selectedImg !== null) {
					selectedImg.classList.remove('aditl__bg-image--selected');
				}
				selectedAnew.classList.add('selected');
				parent.querySelector('.aditl__bg-image[data-background="' + background + '"]').classList.add('aditl__bg-image--selected');
			}
		});
	},

	click(event) {
		event.preventDefault();
		document.querySelector(event.target.hash).scrollIntoView({ behavior: 'smooth' });
	},

	scroll(event) {
		if (event.target.scrollTop < 72) {
			let parent = event.target.closest('.aditl');
			let selectedAold = parent.querySelector('.aditl__nav a.selected');
			let selectedImg = parent.querySelector('.aditl__bg-image--selected');
			if (selectedAold !== null) {
				selectedAold.classList.remove('selected');
			}
			if (selectedImg !== null) {
				selectedImg.classList.remove('aditl__bg-image--selected');
			}
			parent.style.setProperty('--progress-height', '0');								
			parent.querySelector('.aditl__bg-image[data-background="default"]').classList.add('aditl__bg-image--selected');			
		}
	}
};

export { aditl };
